import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class CashAccountViewDetailDTO  {
    _originalTypeClassName = "zERP.BO.CashAccountViewDetailDTO";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
CashAccountViewDetailDTO.translate = translateService;
}
this.CashAccount = new Domain.CashAccount();
this.Debit = null;
this.Credit = null;
this.AA = null;
this.CashAccountViewDetailDTOKey = null;
this._key = this.CashAccountViewDetailDTOKey = 0; 
}

static translate: TranslateService;
_key: any;
Debit:any;
Credit:any;
AA:any;
CashAccount:any;
private _CashAccountViewDetailDTOKey:any;
get CashAccountViewDetailDTOKey(): any {
    return this._CashAccountViewDetailDTOKey;
  }
set CashAccountViewDetailDTOKey(value: any) {
    this._CashAccountViewDetailDTOKey = value;
    this._key = value;
  }
static setCashAccount = ($this, value) => {
var oldValue = $this.CashAccount;
$this.CashAccount = value;
if (value != null) {
}
}


static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.CashAccountViewDetailDTOKey == null || $this.CashAccountViewDetailDTOKey == 0;
            }


}